import type { PortfolioDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { BUSINESS_LOANS_EDIT_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/BusinessLoansForm/businessLoansFormDefaults";
import type { BusinessLoansEditFormInput } from "web_myplann/Portfolio/Forms/BusinessLoansForm/businessLoansFormSchema";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";

export const mapPortfolioToBusinessLoansForm = (
	portfolio: PortfolioDetailResponseDTO,
): BusinessLoansEditFormInput => ({
	name: portfolio.name ?? DEFAULTS.name,
	contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
	producer: portfolio.producer ?? DEFAULTS.producer,
	product: portfolio.product ?? DEFAULTS.product,
	signedAt: parseIsoDate(portfolio.signedAt),
	startAt: parseIsoDate(portfolio.startAt),
	endAt: parseIsoDate(portfolio.endAt),
});
